/** Сегменти TitlePath для форми кампанії за замовчуванням (колишній статичний шлях). */
export const DEFAULT_FORM_TITLE_SEGMENTS: readonly string[] = [
	"Google Ads",
	"Budget",
	"Campaign",
	"Ad Group",
	"App Ad",
];

/** Ключ — значення поля форми `type` з API / WS; значення — крихти для TitlePath (повний шаблон). */
export const FORM_TITLE_PATH_BY_TYPE: Record<string, readonly string[]> =
	Object.freeze({
		// Додайте відповідники з бекенду, напр.: campaign_wizard: DEFAULT_FORM_TITLE_SEGMENTS,
	});

/** Шаблон крихт TitlePath для поточного `type` майстра форми. */
export function getFormTitlePathSegments(formType: string | undefined): string[] {
	const key = String(formType ?? "").trim();
	if (!key) return [...DEFAULT_FORM_TITLE_SEGMENTS];
	const mapped = FORM_TITLE_PATH_BY_TYPE[key];
	if (mapped?.length) return [...mapped];
	return [...DEFAULT_FORM_TITLE_SEGMENTS];
}
